// @ts-nocheck
import { Stack, Typography } from '@mui/material'
import { GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { sum, pluck, uniq } from 'ramda'

import { FieldModel } from '@cibo/core'

interface ProgramColumnFunctionProps {
  programId: string
  t: TFunction
}

export const fieldProgramCreditOpportunityColumn = ({
  programId,
  t,
}: Pick<ProgramColumnFunctionProps, 'programId' | 't'>) => ({
  field: 'credits',
  headerName: t('credits'),
  sortable: false,
  flex: 1,
  minWidth: 220,
  valueGetter: (params: GridValueGetterParams<string, FieldModel>) =>
    sum(
      pluck('credits', params.row.programCreditPerAcrePotential(programId)).filter(
        v => !!v
      ) as number[]
    ) * params.row.acres,
  renderCell: (params: GridRenderCellParams<string, FieldModel>) => {
    const { row: field, value } = params
    const years = uniq(pluck('year', field.programPerAcrePotential(programId) || []))
    const creditYears = uniq(pluck('year', field.programCreditPerAcrePotential(programId) || []))

    if (value === undefined || parseInt(value, 10) <= 0) {
      return '--'
    }
    const start = years.findIndex(y => y === creditYears[0]) + 1
    const end = years.findIndex(y => y === creditYears[creditYears.length - 1]) + 1

    return (
      <Stack>
        <Typography variant="body2">{t('creditsAmount', { credits: value })}</Typography>
        {start !== end && (
          <Typography variant="caption">{t('creditsTime', { start, end })}</Typography>
        )}
      </Stack>
    )
  },
})
